import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, Button, FormGroup, Input, Label } from 'reactstrap';

const ModalIdioma = ({
  isOpen,
  defaultIdiomaId = '1',
  header = 'Idioma del documento',
  onConfirm,
  onCancel,
}) => {
  const [idiomaId, setIdiomaId] = useState(defaultIdiomaId || '1');

  useEffect(() => {
    if (isOpen) setIdiomaId(defaultIdiomaId || '1');
  }, [isOpen, defaultIdiomaId]);

  return (
    <Modal isOpen={isOpen} centered>
      <ModalBody>
        <Label>
          <b>{header}</b>
        </Label>
        <FormGroup check>
          <Input
            type="radio"
            id="modal-idioma-castellano"
            name="modal-idioma"
            checked={idiomaId === '1'}
            onChange={() => setIdiomaId('1')}
          />
          <Label check htmlFor="modal-idioma-castellano">
            Castellano
          </Label>
        </FormGroup>
        <FormGroup check>
          <Input
            type="radio"
            id="modal-idioma-catalan"
            name="modal-idioma"
            checked={idiomaId === '2'}
            onChange={() => setIdiomaId('2')}
          />
          <Label check htmlFor="modal-idioma-catalan">
            Catalán
          </Label>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => onConfirm(idiomaId)}>
          Aceptar
        </Button>
        <Button color="danger" onClick={onCancel}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalIdioma.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  defaultIdiomaId: PropTypes.oneOf(['1', '2']),
  header: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ModalIdioma;
